import {
  Accordion,
  AccordionSummary,
  Box,
  Divider,
  IconButton,
  Stack,
  Typography,
  useTheme,
} from '@mui/material';

import { IcArrowDown, IcPolice } from '@/assets/images';
import { ButtonWithDoubleClickPrevention } from '@/components';
import { colors } from '@/theme/variables';

import { UnitItemRoot } from '../styles';

export const UnitItem = (props: { name: string }) => {
  const theme = useTheme();

  return (
    <UnitItemRoot>
      <Stack className="content-section" alignItems="center">
        <Typography
          variant="button"
          color={theme.palette.text.primary}
          style={{ textTransform: 'none' }}
        >
          {props.name}
        </Typography>
        <Box className="name-box">
          <IcPolice color={colors.grey[80]} style={{ marginTop: -1 }} />
          <Typography variant="subtitle2" color={theme.palette.text.secondary}>
            Police car
          </Typography>
        </Box>
        <Box className="name-box">
          <Typography variant="subtitle2" color={theme.palette.text.secondary}>
            MF
          </Typography>
        </Box>
        <div style={{ flex: 1 }} />
        <ButtonWithDoubleClickPrevention
          color="error"
          variant="contained"
          size="small"
          onClick={() => {}}
          isDisabled={false}
        >
          Assign
        </ButtonWithDoubleClickPrevention>
      </Stack>
      <Divider sx={{ my: '15px' }} />
      <Accordion expanded={false}>
        <AccordionSummary
          onClick={() => {}}
          sx={{ justifyContent: 'space-between' }}
        >
          <Typography
            variant="button"
            color={theme.palette.text.primary}
            style={{ textTransform: 'none' }}
            flex={1}
          >
            Offline
          </Typography>
          <IconButton>
            <IcArrowDown />
          </IconButton>
        </AccordionSummary>
      </Accordion>
    </UnitItemRoot>
  );
};
